import PageNavigationController from 'PageNavigation/PageNavigationController';
import TitleBar from 'MainLayout/TitleBar';
import Content from 'MainLayout/Content';
import Footer from 'MainLayout/Footer';
import ModalDialog from 'MainLayout/ModalDialog';
import { dicontainer } from "DIContainer";
import Modal from "PageNavigation/Modal";
import IEmptyProps from "EmptyProps";
import { DOMUtils, ElementStyleAnimation, HTMLElementProperty, HTMLElementPropertyUnit, SimpleEventArgs } from 'ts-common-utils';
import React from 'react';
import classNames from 'classnames';

interface IMainState  {
    modal?: Modal;
}

export default class Main extends React.Component<IEmptyProps, IMainState> {
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);
    private _titleBarAnimation?: ElementStyleAnimation;

    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            modal: undefined
        };
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this._pageNavigationController.onShowModal.addHandler(this.handleShowModal);
        this._pageNavigationController.onCloseModal.addHandler(this.handleCloseModal);
        this._pageNavigationController.onScroll.addHandler(this.handleScroll);
    }

    public componentDidMount() {
        this._pageNavigationController.notifyAppMounted();
        this._titleBarAnimation = new ElementStyleAnimation(DOMUtils.findFirst(".title-bar.desktop"), {
            duration: 400,
            targetPropertyValues: {[HTMLElementProperty.Height]: {value: 60, unit: HTMLElementPropertyUnit.Pixel}}
        });
    }

    public handleScroll(sender: object, e: SimpleEventArgs<Event>) {
        let element = e.value.target as HTMLDivElement;
        this._titleBarAnimation!.setEffectiveProgress(Math.min(element.scrollTop / 60, 1));
    }

    public handleShowModal(sender: object, e: SimpleEventArgs<Modal>) {
        this.setState({ modal: e.value});
    }

    public handleCloseModal() {
        this.setState({ modal: undefined });
    }

    public render() {
        return (
            <div className={classNames("app-container", {"modal-opened": this.state.modal != undefined})}>
                {this.state.modal &&
                    <ModalDialog name={this.state.modal.name} title={this.state.modal.title} subtitle={this.state.modal.subtitle} >
                        {this.state.modal.content}
                    </ModalDialog>
                }
                <TitleBar />
                <Content />
                <Footer />
            </div>
        );
    }
}